import H from 'history';
import adobeTags from 'src/types/adobe-tags';
import { ButtonSecondary } from '@americanexpress/dls-react';
import { trackClick } from 'src/hooks/useAdobeTags';
import { goToBudgetPersonalize } from 'src/services/router.service';
import { DLSSize } from 'src/types/dls-size.enum';
import styles from './budgetEditButton.module.scss';
import Selectors from 'src/utils/selectors';
import LiteralsService from 'src/services/literals/LiteralsService';
import { GlyphRight } from '@americanexpress/dls-icons';
import React from 'react';

interface BudgetEditButtonProps {
    history: H.History;
    hasBudgets: boolean;
    isFullPlanUser: boolean;
    isMinWidthSmall?: boolean;
}

export default function BudgetEditButton({
    history,
    hasBudgets,
    isFullPlanUser,
    isMinWidthSmall
}: BudgetEditButtonProps): JSX.Element {
    const getTag = (): string => {
        if (hasBudgets) return adobeTags.CurrentMonth.EditBottom;
        return adobeTags.CurrentMonth.CreateBudgetBottom;
    };

    return (
        <ButtonSecondary
            onClick={() => {
                trackClick(history.location.pathname, getTag());
                goToBudgetPersonalize(isFullPlanUser, history);
            }}
            size={isMinWidthSmall ? DLSSize.SMALL : DLSSize.MEDIUM}
            className={styles.editBudgetButton}
            data-cy={Selectors.SpendSmart.HOME_EDIT_BUDGET_BUTTON}
        >
            {hasBudgets
                ? LiteralsService.getLiteral('BudgetEditButton.edit')
                : LiteralsService.getLiteral('BudgetEditButton.create')}
            <GlyphRight />
        </ButtonSecondary>
    );
}
